/**
 * Canonical NiData user-visible loading text.
 * @see .cursor/rules/nidata/loading-copy-standard.mdc
 */
export const NIDATA_LOADING_LABEL = 'กำลังโหลด...';
